/* eslint-disable react-refresh/only-export-components */
import { DEFAULT_COOKIE_EXPIRES_SECONDS, getCookie, setCookie } from "@/utils/cookie";
import { createContext, use, useState, useEffect, useMemo, useCallback, type ReactNode } from "react";

interface DataTableContextType {
	fontSize: number;
	setFontSize: (size: number) => void;
}

const DataTableContext = createContext<DataTableContextType | undefined>(undefined);

export function DataTableProvider({ children }: { readonly children: ReactNode }) {
	const [fontSizeState, setFontSizeState] = useState(() => {
		const saved = getCookie("dataTableFontSize");
		return saved ? parseInt(saved) : 11;
	});

	const setFontSize = useCallback((size: number) => {
		setFontSizeState(size);
	}, []);

	useEffect(() => {
		setCookie("dataTableFontSize", fontSizeState.toString(), {
			path: "/",
			expires: DEFAULT_COOKIE_EXPIRES_SECONDS.oneWeek,
		});
	}, [fontSizeState]);

	const contextValue = useMemo(() => ({ fontSize: fontSizeState, setFontSize }), [fontSizeState, setFontSize]);
	return <DataTableContext value={contextValue}>{children}</DataTableContext>;
}

export function useDataTableContext() {
	const context = use(DataTableContext);
	if (!context) throw new Error("useDataTable must be used within a DataTableProvider");

	return context;
}
